import { X_API_VERSION } from "./xApiVersion";
import { getCmi5 } from "./cmi5";
import { Assert } from "@/common/Assert";
/**
 * The code was taken and adapted from
 * https://github.com/adlnet/CATAPULT/blob/main/course_examples/masteryscore_framed/js/course_cmi5.js
 */
/**
 * Retrieve the activity state for this learner and registration at the given stateId.
 *
 * @param {string} stateId   The xAPI Activity State "stateId" value for the API call.
 * @return {Promise<any>} The promise returned by the fetch call representing the xAPI request.
 */
export function getActivityState(stateId) {
    Assert.checkArgument(stateId);
    const cmi5 = getCmi5();
    return fetch(buildRequestUrl(stateId), {
        mode: "cors",
        method: "get",
        headers: {
            "X-Experience-API-Version": X_API_VERSION,
            Authorization: cmi5.getAuth()
        }
    })
        .then(response => {
        if (response.status === 200) {
            return Promise.resolve(response.json());
        }
        return Promise.resolve(undefined);
    })
        .catch(ex => {
        return Promise.reject(new Error(`Failed to GET activity state: ${ex}`));
    });
}
/**
 * Store the data provided as an activity state for this learner and registration at the given stateId.
 *
 * @param {string} stateId     The xAPI Activity State "stateId" value for the API call.
 * @param data                 The data to store in this Activity State.
 * @return {Promise<any>} The promise returned by the fetch call representing the xAPI request.
 */
export function setActivityState(stateId, data) {
    Assert.checkArgument(stateId);
    Assert.checkArgument(data);
    const cmi5 = getCmi5();
    return fetch(buildRequestUrl(stateId), {
        mode: "cors",
        method: "put",
        headers: {
            "X-Experience-API-Version": X_API_VERSION,
            Authorization: cmi5.getAuth(),
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
        .then(response => {
        if (response.status === 200) {
            return response.json();
        }
        return Promise.resolve(undefined);
    })
        .catch(ex => {
        return Promise.reject(new Error(`Failed to GET activity state: ${ex}`));
    });
}
function buildRequestUrl(stateId) {
    const cmi5 = getCmi5();
    const params = new URLSearchParams({
        stateId: stateId,
        activityId: cmi5.getActivityId(),
        agent: JSON.stringify(cmi5.getActor()),
        registration: cmi5.getRegistration()
    });
    return `${cmi5.getEndpoint()}/activities/state?${params}`;
}
